import { cncMiniLazyload } from '@default/scripts/modules/lazy-load/cncMiniLazyload';
import { captcha } from './modules/thank-you/captcha';
import { form } from './modules/thank-you/form';

cncMiniLazyload();
captcha();
form();
